<template>
	<div class="message-controls">
		<img v-if="$store.state.user.user.photoURL" :src="$store.state.user.user.photoURL" />
		<no-user-image
			v-else
			class="no-user-image"
			:firstName="$store.state.user.user.firstName"
			:lastName="$store.state.user.user.lastName"
			:fontSize="13"
			:height="'30px'"
			:width="'50px'"
		></no-user-image>
		<textarea
			type="text"
			rows="3"
			placeholder="Type message"
			maxlength="140"
			v-model="message"
			@keypress.enter="sendMessage"
		></textarea>
		<span class="message-count">{{message.length}}/140</span>
		<button
			type="button"
			class="button send-button"
			:disabled="messageDisabled"
			@click="sendMessage"
			@keyup.enter="sendMessage"
		>
			<!-- Send -->
			<ion-icon name="paper-plane"></ion-icon>
		</button>
	</div>
</template>

<script>
import { db } from "../../../resources/firebase";
import firebase from "firebase/app";
import NoUserImage from "../../errors/NoUserImage.vue";

export default {
	data() {
		return {
			message: "",
			messageDisabled: true
		};
	},
	props: {
		groupID: {
			type: String
		}
	},
	components: {
		NoUserImage
	},
	methods: {
		sendMessage() {
			const authUser = this.$store.state.user.authUser.uid;

			if (/\S/.test(this.message)) {
				if (this.message !== "" && this.message.length <= 140) {
					db.collection("test_groups")
						.doc(this.groupID)
						.collection("messages")
						.add({
							message: this.message,
							senderID: authUser,
							dateCreated: Date.now()
						})
						.then(docRef => {
							db.collection("test_groups")
								.doc(this.groupID)
								.collection("messages")
								.doc(docRef.id)
								.update({
									id: docRef.id
								})
								.then(() => {
									this.message = "";
									this.messageDisabled = true;
								})
								.catch(error => {
									// console.log(error);
									throw new Error(error);
								});
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				}
			} else {
				this.messageDisabled = true;
			}
		}
	},
	watch: {
		message(val) {
			if (/\S/.test(val)) {
				if (val !== "" && val.length <= 140) {
					this.messageDisabled = false;
				} else {
					this.messageDisabled = true;
				}
			} else {
				this.messageDisabled = true;
			}
		}
	}
};
</script>

<style scoped>
.message-controls {
	/* position: absolute; */
	width: 100%;
	height: 30%;
	/* bottom: 40px; */
	padding-top: 15px;
	border-top: 1px solid #111;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.message-controls textarea {
	resize: none;
	width: -webkit-fill-available;
	margin: 0 10px 0 0 !important;
}

.message-controls button {
	background-color: rgb(0, 110, 255);
	border-color: rgb(0, 110, 255);
	color: #fff;
}

.message-controls button:hover {
	color: #fff;
	background-color: rgb(2, 100, 228);
	border-color: rgb(2, 100, 228);
}

.message-controls button:disabled {
	background-color: #171717;
	color: #555;
	border-color: #555;
}

.message-count {
	position: absolute;
	font-size: 9px;
	font-weight: bold;
	background-color: rgba(128, 128, 128, 0.5);
	color: #51c715;
	border-radius: 10px;
	padding: 2px 5px;
	right: 95px;
	/* top: 25px; */
	margin-top: 10px;
}

img {
	height: 30px;
	width: 30px;
	border-radius: 50%;
	margin-right: 10px;
	object-fit: cover;
	/* align-self: flex-end; */
}

.no-user-image {
	/* height: 50px !important;
        width: 50px !important; */
	border-radius: 50%;
	background-color: rgba(81, 199, 21, 0.34);
	margin-right: 10px;
}

ion-icon[name="paper-plane"] {
	font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsMessage/GroupsMessageControls.vue